export default __webpack_public_path__ + "static/media/Legend1.dc411219.jpeg";